import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  textField: {
    width: '100%',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    '& .MuiPaper-root': {
      elevation: 3,
    },
    maxWidth: '100%',
  },
  title: {
    flexGrow: 1,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '200px',
  },
  dropzone: {
    // '#ccc' is exactly `imageBorder`; '#f8f9fa' -> `dropzoneBackground`
    // ('#fafafa'), a 0.4% shift in light mode.
    border: `2px dashed ${theme.palette.custom.imageBorder}`,
    borderRadius: '8px',
    padding: '40px',
    textAlign: 'center',
    backgroundColor: theme.palette.custom.cardBackground,
    cursor: 'pointer',
    '&.dragOver': {
      // '#007bff' is exactly `infoButtonBackground`.
      borderColor: theme.palette.custom.infoButtonBackground,
      backgroundColor: theme.palette.custom.dropzoneBackground,
    },
  },
  fileInput: {
    display: 'none',
  },
  fileList: {
    marginTop: '20px',
  },
  fileItem: {
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
  },
  removeButton: {
    background: 'none',
    border: 'none',
    color: theme.palette.custom.dangerAccent,
    cursor: 'pointer',
    fontSize: '16px',
    marginRight: '10px',
  },
  fileContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  imagePreview: {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '4px',
  },
}));

export default useStyles;
